<script>
    /**
     * This is a pane within an [ib-tab-container](#/components/layout/ib-tab-container) container. It displays
     * content associated with an [ib-tab](#/components/layout/ib-tab).
     */
    export default {
        name: 'ib-tab-pane',

        created() {
            const con = this.$parent;
            if (con.isTabContainer) {
                con.sync();
                this.con = parent;
            }
        },

        destroyed() {
            const con = this.con;
            if (con && con.sync) {
                con.sync();
            }
        },

        render(h) {
            // vue-docgen-api
            if (0) {
                /**
                 * @slot Pane content goes in the default slot.
                 */
                const d = this.$slots.default;
            }

            const vm = this;
            return h('div', {
                'staticClass': '_tabp2'
            }, [
                vm._t('default')
            ]);
        }
    }
</script>

<style lang="less">
    @import "../../less/globals.less";

    ._tabp2 {
        flex: 0 0 100%;
        overflow: auto;
        scroll-snap-align: start;
    }
</style>
